import React from 'react';
import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import {Label, TextBig} from '~atoms/Text';
import CopyToClipboardWithTooltip from '~components/atoms/CopyToClipboardWithTooltip';
import {PlotDetailsResponse} from '~types/Plots';
import {getHashId} from '~utils/map/events/useSelectPlotEvent';
import {usePlotName} from '~utils/plot/address';

import {TitleRow} from './styles';

type PlotTitleProps = {
    plot?: PlotDetailsResponse;
    withCopy?: boolean;
};

const PlotTitle: React.FC<PlotTitleProps> = ({plot, withCopy}) => {
    const name = usePlotName(plot);
    const t = useScopeTranslation('map', 'preview');

    return (
        <>
            <TitleRow>
                <TextBig>{name}</TextBig>
                {withCopy && plot && (
                    <CopyToClipboardWithTooltip
                        text={`${window.location.origin}/#${getHashId(plot.id)}`}
                        type="link"
                    />
                )}
            </TitleRow>
            {plot?.reservationOwner && (
                <Label>
                    {t('reservationOwner', {owner: plot?.reservationOwner})}
                </Label>
            )}
        </>
    );
};

export default PlotTitle;
